import { ofType, type ActionsObservable } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, concatMap, map } from 'rxjs/operators';
import {
  LoadConfigReportsFailure,
  LoadConfigReportsSuccess,
  LoadReportsFailure,
  LoadReportsSuccess,
  PowerBIReportsActionsTypes,
  type LoadConfigReports,
  type LoadReports
} from './powerbi-reports.actions';
import { getConfigsReports, getReports } from './powerbi-reports.service';

export const handleLoadPowerBIReports = (action$: ActionsObservable<ReturnType<typeof LoadReports>>) =>
  action$.pipe(
    ofType(PowerBIReportsActionsTypes.LOAD_REPORTS),
    map(action => action.payload),
    concatMap(payload =>
      getReports(payload.organizationId, payload.configID).pipe(
        map(response => {
          return LoadReportsSuccess(response);
        }),
        catchError((err: string) => of(LoadReportsFailure(err)))
      )
    )
  );

export const handleLoadConfigPowerBIReports = (action$: ActionsObservable<ReturnType<typeof LoadConfigReports>>) =>
  action$.pipe(
    ofType(PowerBIReportsActionsTypes.LOAD_CONFIG_REPORTS),
    map(action => action.payload),
    concatMap(payload =>
      getConfigsReports(payload.organizationId).pipe(
        map(response => {
          return LoadConfigReportsSuccess(response);
        }),
        catchError((err: string) => of(LoadConfigReportsFailure(err)))
      )
    )
  );
